











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ResHelper } from '@/helper/ResHelper';
import { LoadingState } from '@/entities/LoadingState';
import * as l10n from '@/constants/l10n';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { Country } from '@/entities/Country';
import { CountryOption } from './CountryOption';
import { StateOption } from './StateOption';
import { RootState } from '@/store/rootState';
import { State } from '@/entities/State';
import { CountryStateSelectModuleTypes } from '@/store/modules/country-state-select';

@Component({})
export default class CountryStateSelect extends Vue {
    @Prop(Boolean)
    public disabled!: boolean;
    @Prop(String)
    public countrySelectName!: string;
    @Prop(String)
    public countrySelectLabel!: string;
    @Prop(String)
    public countryHiddenInputId!: string;
    @Prop(String)
    public stateSelectName!: string;
    @Prop(String)
    public stateSelectLabel!: string;
    @Prop(String)
    public stateHiddenInputId!: string;
    public loadingState: typeof LoadingState = LoadingState;

    public get countryOptions(): CountryOption[] {
        return this.$store.getters[
            CountryStateSelectModuleTypes.getters.countries
        ].map((country: Country) => ({
            label: ResHelper.getStringOrFallback(
                l10n.COUNTRY.For(country.key),
                country.name
            ),
            country,
        }));
    }

    public get countriesLoadingState(): LoadingState {
        return this.$store.getters[
            CountryStateSelectModuleTypes.getters.countriesLoadingState
        ];
    }

    public get selectedCountryOption(): CountryOption | null {
        const country = this.$store.getters[
            CountryStateSelectModuleTypes.getters.selectedCountry
        ](this.countryHiddenInputId) as Country;
        if (country) {
            return {
                label: ResHelper.getStringOrFallback(
                    l10n.COUNTRY.For(country.key),
                    country.name
                ),
                country,
            };
        }
        return null;
    }

    public get stateOptions(): StateOption[] {
        return this.$store.getters[
            CountryStateSelectModuleTypes.getters.statesOfSelectedCountry
        ](this.countryHiddenInputId).map((state: State) => ({
            label: ResHelper.getStringOrFallback(
                l10n.STATE.For(state.key),
                state.name
            ),
            state,
        }));
    }

    public get statesLoadingState(): LoadingState {
        return this.$store.getters[
            CountryStateSelectModuleTypes.getters.statesLoadingState
        ](this.countryHiddenInputId);
    }

    public get selectedStateOption(): StateOption | null {
        const state = this.$store.getters[
            CountryStateSelectModuleTypes.getters.selectedState
        ](this.countryHiddenInputId) as State;
        if (state) {
            return {
                label: ResHelper.getStringOrFallback(
                    l10n.STATE.For(state.key),
                    state.name
                ),
                state,
            };
        }
        return null;
    }

    @Watch('selectedCountryOption')
    public updateCountryValue(countryOption: CountryOption | null): void {
        const countryInput = document.getElementById(
            this.countryHiddenInputId
        ) as HTMLInputElement | null;
        if (!countryInput) {
            return;
        }
        if (countryOption) {
            countryInput.value = String(countryOption.country.id);
        } else {
            countryInput.value = '';
        }
        const event = new Event('change');
        countryInput.dispatchEvent(event);
    }

    @Watch('selectedStateOption')
    public updateStateValue(stateOption: StateOption | null): void {
        const stateInput = document.getElementById(
            this.stateHiddenInputId
        ) as HTMLInputElement | null;
        if (!stateInput) {
            return;
        }
        if (stateOption) {
            stateInput.value = String(stateOption.state.id);
        } else {
            stateInput.value = '';
        }
        const event = new Event('change');
        stateInput.dispatchEvent(event);
    }

    @Watch('countriesLoadingState')
    public setExistingCountryAndStateValue(
        countriesLoadingState: LoadingState | null
    ): void {
        if (
            countriesLoadingState &&
            countriesLoadingState === LoadingState.Loaded
        ) {
            const countryInput = document.getElementById(
                this.countryHiddenInputId
            ) as HTMLInputElement | null;
            const stateInput = document.getElementById(
                this.stateHiddenInputId
            ) as HTMLInputElement | null;
            if (!countryInput || !stateInput) {
                return;
            }

            const countryId = Number(countryInput.value);
            const stateId = Number(stateInput.value);
            if (countryId > 0) {
                this.$store.dispatch(
                    CountryStateSelectModuleTypes.actions
                        .selectCountryAndStateById,
                    {
                        id: this.countryHiddenInputId,
                        countryId,
                        stateId,
                    }
                );
            }
        }
    }

    public countrySelected(countryOption: CountryOption): void {
        this.$store.dispatch(
            CountryStateSelectModuleTypes.actions.selectCountry,
            {
                id: this.countryHiddenInputId,
                country: countryOption.country,
            }
        );
    }

    public stateSelected(stateOption: StateOption): void {
        this.$store.dispatch(
            CountryStateSelectModuleTypes.actions.selectState,
            {
                id: this.countryHiddenInputId,
                state: stateOption.state,
            }
        );
    }

    protected created(): void {
        this.$store.dispatch(
            CountryStateSelectModuleTypes.actions.registerSelect,
            {
                id: this.countryHiddenInputId,
            }
        );
    }
}
